import React from "react";
import {
  Route,
  Switch,
  Redirect,
  withRouter,
} from "react-router-dom";
import classnames from "classnames";
import { withStyles } from '@material-ui/styles';
import Cookies from 'universal-cookie';

import Header from "../AdminLayout/Header";
import AdminSidebar from "../AdminSidebar/AdminSidebar";
import AddClient from '../../pages/mainAdmin/addClient';

// pages
import Clients from "../../pages/mainAdmin/Clients";
import EditClient from "../../pages/editClient/EditClient";
import AdminSettings from "../../pages/mainAdmin/AdminSettings";
import Tickets from "../../pages/mainAdmin/Tickets";
import AdminTicketDetails from "../../pages/mainAdmin/TicketsDetails";

const makeStyles = theme => ({
  root: {
    display: "flex",
    maxWidth: "100vw",
    overflowX: "hidden",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    width: `calc(100vw - 240px)`,
    minHeight: "100vh",
  },
  contentShift: {
    width: `calc(100vw - ${240 + theme.spacing(6)}px) `,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  fakeToolbar: {
    ...theme.mixins.toolbar,
  },
});

class AdminLayout extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      menuItems: []
    }
  }

  render (){

    // global
    const { classes } = this.props;

    
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const userType = cookies.get('userType', { path: '/' });
    const mode = cookies.get('mode', { path: '/' });

    return (
      <div className={classes.root}>
          <>
            <Header history={this.props.history} />
            <AdminSidebar menuItems={this.state.menuItems}/>
            
            <div
              className={classnames(classes.content, {
                [classes.contentShift]: null,
              })}
            >
              <div className={classes.fakeToolbar} />
             
              <Switch>

              <Route path="/admin/clients" component={Clients} />
              <Route path="/admin/addClient" component={AddClient} />
              <Route path="/admin/editClient" component={EditClient} />
              <Route path="/admin/settings" component={AdminSettings} />
              <Route path="/admin/tickets" component={Tickets} />
              <Route path="/admin/ticketDetails" component={AdminTicketDetails} />

                <Route
                  exact
                  path="/admin/ui"
                  render={() => <Redirect to="/admin/ui/icons" />}
                />
              </Switch>
            </div>
            <div
              className={classnames(classes.contentPhone)}
            >
            </div>
          </>
      </div>
    );
  }
  
}

export default withStyles(makeStyles)(withRouter(AdminLayout));
